import { salesCodes } from "../../../data/main";
import { stdObject } from "../../../data/types/stdObject";
import { sendData } from "../../../services/sendData";
import { getCurrentDate } from "../../../utils/getCurrentDate";
import { getItemType } from "../../../utils/getItemType";

export const createDocTransfer = async ({
  docValues,
  modalData,
  setMsg,
  closeMsg,
  staffList,
  logoutAction,
}: stdObject) => {
  setMsg("loading");
  const { type, itemType, serie, code } = docValues;
  const nextItemType = getItemType(modalData.target);

  const payloadDocTransfer = {
    type: modalData.target,
    itemType: nextItemType,
  };

  console.log("payloadDocTransfer: ", payloadDocTransfer);
  const resultDocTransferInfo: stdObject = await sendData({
    endPoint: "nextDocInfo",
    payload: payloadDocTransfer,
    logoutAction,
  });

  console.log("resultDocTransferInfo", resultDocTransferInfo);

  const data: stdObject = {};
  resultDocTransferInfo.docKeys.forEach((e: string) => {
    const prefix = e.slice(0, -3);
    if (
      ![
        "WEB",
        "EST3",
        "NOT",
        "EST1",
        "EST2",
        "EST3",
        "REL",
        "USU",
        "UMO",
        "ABR",
        "NAB",
        "ADJ",
      ].includes(prefix)
    ) {
      switch (prefix) {
        case "COD":
          data[e] = 0;
          break;
        case "FEC":
          data[e] = getCurrentDate(true);
          break;
        case "NET":
        case "IMP":
        case "TOT":
        case "PCO":
        case "OBS":
          data[e] = modalData[prefix];
          break;
        default:
          if (prefix + type in docValues.data) {
            data[e] = docValues.data[prefix + type].value;
          }
          break;
      }
    }
  });

  const items: stdObject[] = [];
  modalData.items
    .filter((e: stdObject) => e.active && Number(e.quantity) > 0)
    .forEach((e: stdObject) => {
      let tempValues: stdObject = {};

      resultDocTransferInfo.itemsKeys.forEach((v: string) => {
        const prefix = v.slice(0, -3);
        switch (prefix) {
          case "COD":
          case "PEN":
            tempValues[v] = 0;
            break;
          case "CAN":
            tempValues[v] = e.quantity;
            break;
          case "TOT":
            tempValues[v] = e.quantity * e[`PRE${itemType}`];
            break;
          default:
            if (prefix + itemType in e) {
              tempValues[v] = e[prefix + itemType];
            }
            break;
        }
      });

      items.push(tempValues);
    });

  const staff: stdObject = {};
  staffList
    .filter((e: stdObject) => e.DOCIA1 === modalData.target)
    .forEach((e: stdObject) => {
      if (docValues.staff[e.CODIA1] && docValues.staff[e.CODIA1].value > 0) {
        staff[e.CODIA1] = {
          id: docValues.staff[e.CODIA1].value,
          name: docValues.staff[e.CODIA1].name,
        };
      }
    });

  const commissions = salesCodes.includes(type)
    ? docValues.commissions.filter((e: stdObject) => {
        let accepted = false;
        Object.keys(staff).forEach((v: string | number) => {
          if (
            !accepted &&
            staff[v].id === e.AGECOY &&
            items.some((o: stdObject) => o[`LIN${nextItemType}`] === e.LINCOY)
          ) {
            accepted = true;
          }
        });
        return accepted;
      })
    : [];

  const payloadCreateDocTransfer = {
    serie,
    type: modalData.target,
    itemType: nextItemType,
    data,
    items,
    batches: [], // docValues.batches, //
    commissions,
    staff,
    files: [],
    prevDoc: type,
    prevCode: code,
  };

  console.log("payloadCreateDocTransfer", payloadCreateDocTransfer);

  const resultCreateDocTransfer: stdObject = await sendData({
    endPoint: "saveDocument",
    payload: payloadCreateDocTransfer,
    logoutAction,
  });
  console.log(
    "resultCreateDocTransfer",
    Object.values(resultCreateDocTransfer).join(""),
  );
  closeMsg();
};
